(ns iris.posts.events
  (:require
   [re-frame.core :as re-frame]
   [iris.events :as events]
   [iris.utils :as utils]
   [iris.hench :as hench]
   [cljs.core.async :refer [go go-loop <! chan take!]]
   [cljs.core.async.interop :refer-macros [<p!]]
   [iris.firebase :as fb]
   [iris.indexeddb :as idb]
   [iris.localstorage :as localstorage]
   [day8.re-frame.async-flow-fx :as async-flow-fx]
   [iris.routes :as routes]
   [clojure.string :as string]
   [iris.globals :as globals]

   [iris.posts.common :refer [ruid-to-ahref]]
   [iris.posts.helpers :refer [add-ws-to-refs
                               decode-post-actions-state
                               get-scopes-from-query-params]]
   [iris.posts.actions]
   [iris.posts.background :as background]
   [iris.posts.headers]
   [iris.posts.ref-preview :as ref-preview]
   [iris.posts.screening :as screening]

   [iris.error.events :as error-events]

   [iris.sessionstorage :as sessionstorage]

   [iris.worker-pool :as worker-pool]
   ))

(def route-load-meta-key ::route-load)

(defn with-route-load [query-params route-load]
  (with-meta query-params
    (assoc (meta query-params) route-load-meta-key route-load)))

(defn query-route-load [query-params]
  (get (meta query-params) route-load-meta-key))

(defn same-route-load? [db route-load]
  (and (some? route-load)
       (= route-load (get-in db [:posts :route-load]))))

(defn complete-route-load [db route-load]
  (if (same-route-load? db route-load)
    (assoc-in db [:posts :route-loading?] false)
    db))

(defn start-route-posts-load [db {:keys [panel route-rev load-key]}]
  (-> db
      (assoc-in [:posts :data] [])
      (assoc-in [:posts :meta] nil)
      (assoc-in [:posts :batch-meta] nil)
      (assoc-in [:posts :route-loading?] true)
      (assoc-in [:posts :route-load] {:panel panel
                                      :route-rev route-rev
                                      :load-key load-key})))

;; TODO: http complete is repeated in each section
;; TODO: in events it's called "set-loading"
(re-frame/reg-event-db
 ::http-complete
 (fn [db [_ data]]
   (assoc db :loading false)))

(re-frame/reg-event-db
 ::http-loading
 (fn [db [_ value]]
   (assoc db :loading value)))

(re-frame/reg-event-db
 ::route-posts-load-started
 (fn [db [_ {:keys [panel route-rev load-key]}]]
   (start-route-posts-load db {:panel panel
                               :route-rev route-rev
                               :load-key load-key})))

(re-frame/reg-event-db
 ::route-posts-load-complete
 (fn [db [_ route-load]]
   (complete-route-load db route-load)))


(re-frame/reg-event-db
 ::set-font-size
 (fn [db [_ data]]
   (assoc-in db [:posts :font-size] (int data))))

(re-frame/reg-event-fx
 ::inc-font-size
 (fn [{:keys [db]} [_]]
   (let [font-size (get-in db [:posts :font-size])]
     (if (< font-size 300)
       (let [new-font-size (+ font-size 10)]
         (localstorage/set-item! "iris.post.font-size" new-font-size)
         {:db (assoc-in db [:posts :font-size] new-font-size)})
       {}))))

(re-frame/reg-event-fx
 ::dec-font-size
 (fn [{:keys [db]} [_]]
   (let [font-size (get-in db [:posts :font-size])]
     (if (> font-size 0)
       (let [new-font-size (- font-size 10)]
         (localstorage/set-item! "iris.post.font-size" new-font-size)
         {:db (assoc-in db [:posts :font-size] new-font-size)})
       {}))))

(defn get-distinct-eids [result-data]
  (distinct
   (loop [v []
          d result-data]
     (if-not (empty? d)
       (let [eid (:eid (:author (first d)))
             eid-vals (filterv some? (vals eid))]
         (recur (into v eid-vals) (rest d)))
       v))))


(defn raidize-post-author-eid [author-eid]
  (go-loop [eid-keys (keys author-eid)
            raids {}]
    (if (> (count eid-keys) 0)
      (let [k (first eid-keys)
            v (k author-eid)
            raid (if (some? v) (<p! (idb/get-raid v)) nil)
            new-raids (if (some? raid) (conj {k raid} raids) raids)
            rest-eid-keys (rest eid-keys)]
        (recur rest-eid-keys new-raids))
      raids)))


(re-frame/reg-event-db
 ::set-posts-meta
 (fn [db [_ data]]
   (assoc-in db [:posts :meta] data)))

(re-frame/reg-event-db
 ::set-posts-data
 (fn [db [_ data route-load]]
  ;;  checks to make sure data we are updating is the same
  ;;  TODO: perhaps sorting should happen prior to comparison
  ;;  even better ::set-post-fb-data should be stopped
  ;;  furthermore, set-post-list-data should have similar mechanism for validation
  ;;  again, even better, should be stopped
  ;;  (if (= (map :id (get-in db [:posts :data]))
  ;;         (map :id data))
  ;;    (assoc-in db [:posts :data] data)
  ;;    db)

   (-> db
       (assoc-in [:posts :data] data)
       (complete-route-load route-load))
   ))

(re-frame/reg-event-db
 ::set-fb-data
 (fn [db [_ k data]]
   (update-in db [:posts :fb-data k] merge data)
   ))

(re-frame/reg-event-db
 ::set-fb-data-row
 (fn [db [_ k id data]]
   (assoc-in db [:posts :fb-data k id] data)))

(re-frame/reg-event-db
 ::set-posts-data-row-prop
 (fn [db [_ index k value]]
   (assoc-in db [:posts :data index k] value)))

;; NOTE: we have "::update-post-props" event already
(re-frame/reg-event-db
 ::update-posts-data-row
 (fn [db [_ ruid data]]
   (assoc-in db [:posts :data] (mapv #(if (= ruid (:ruid %)) data %) (get-in db [:posts :data])))))

(defn on-update-fb-data-replies [thread data]
  (re-frame/dispatch [::set-fb-data-row :replies (str "@OP" thread) data]))

(defn on-update-fb-data-votes [nick thread data]
  (println "on-update-fb-data-votes::" nick thread data (keyword (str nick thread)))
  (re-frame/dispatch [::set-fb-data-row :votes
                      (keyword (str nick thread))
                      data]))



(defn select-posts-fb-data-keys [posts-data]
  (loop [data posts-data
         select-posts-data []]
    (let [d (first data)
          r (rest data)
          s (select-keys d [:ws :forum :thread :level :id])]
      (if (not-empty r)
        (recur r (conj select-posts-data s))
        (conj select-posts-data s)))))


(defn set-fb-data-votes [posts-votes-data]
  (re-frame/dispatch [::set-fb-data :votes (:result posts-votes-data)]))

(defn set-fb-data-replies [posts-replies-data]
  (re-frame/dispatch [::set-fb-data :replies (:result posts-replies-data)]))

(defn set-fb-data-logs [result-data]
  (when-let [logs (not-empty (get-in result-data [:result :logs]))]
    (re-frame/dispatch [::set-admin-all-moderation-logs-2 logs]))
  (when-let [updates (not-empty (get-in result-data [:result :updates]))]
    (doseq [[k v] updates]
      (re-frame/dispatch [::update-post-props (name k) v]))))


(re-frame/reg-event-fx
 ::set-post-fb-data
 (fn [{:keys [db]} [_ result-data]]
   (let [posts-data (or result-data (get-in db [:posts :data]))]

     (loop [data (partition-all 5 (select-posts-fb-data-keys posts-data))]
       (let [d (first data)]

         (take! (worker-pool/do! {:handler :get-posts-votes, :arguments {:data d}}) set-fb-data-votes)
         (take! (worker-pool/do! {:handler :get-posts-replies, :arguments {:data d}}) set-fb-data-replies)
         (take! (worker-pool/do! {:handler :get-admin-all-moderation-logs :arguments {:data d :batch-datetime (get-in db [:posts :batch-datetime])}}) set-fb-data-logs))

         (when-let [r (not-empty (rest data))]
           (recur r))))
   {}))


(defn set-fb-data-eid-raid [raidized-eids]
  (re-frame/dispatch [::set-fb-data :eid-raid (get-in raidized-eids [:result])]))

(re-frame/reg-event-fx
 ::set-post-fb-data-eid-raid
 (fn [{:keys [db]} [_ result-data]]
   ;; distinct eids partitions (deps). 16 eids in each partition.
   (loop [deps (partition-all 16 (get-distinct-eids result-data))]
     (let [dep (first deps)]

       (take! (worker-pool/do! {:handler :raidize-eids, :arguments {:data dep}}) set-fb-data-eid-raid)

       (when-let [r (not-empty (rest deps))]
         (recur r))))
   {}))


;; this function receives individual posts and their moderator logs from fb,
;; sorts them, determines which ones are new (came after the currently displayed post batch list)
;; and updates their local posts state data
;; decode-post-actions-state
;; NOTE: moved to worker!
(defn post-logs-update [d logs batch-datetime]
  (when (> (count logs) 0)
    ;; filter out fresh logs sorted in ascending order and reduce to a flat map containing updates
    (let [logs-asc (sort-by
                    :ms
                    logs)
          logs-new (filter #(>
                             (:ms %)
                             batch-datetime) logs-asc)
          ]


      (when-not (empty? logs-new)
        (let [logs-new-last (last logs-new)
              logs-new-last-decoded (decode-post-actions-state (:state1 logs-new-last))
              updates (conj logs-new-last-decoded {:qc_by (:uid logs-new-last)})]
          (re-frame/dispatch [::update-post-props (:id d) updates]))
        ))))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; Periodically takes data from [:posts :data] based on interval
;; OR uses fresh data from Post.List rpc call provided through args
;; and gets all logs moderation data from firebase for those post ids
;; finally, passed new log data based on [:posts :batch-datetime] to a function
;; that updates in real time [:posts :data] with any changes that might have occured
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; NOTE: moved to worker!
(re-frame/reg-event-fx
 ::admin-all-moderation-logs
 (fn [{:keys [db]} [_ dd]]
   {}))


(defn set-fb-data-personal-logs [result-data]
  (re-frame/dispatch [::set-admin-moderation-logs (get-in result-data [:result :logs])]))

(re-frame/reg-event-fx
 ::personal-moderation-logs
 (fn [{:keys [db]} [_ ws]]

  ;; perhaps "uid" should be passed in?
   (take! (worker-pool/do! {:handler :get-admin-personal-moderation-logs, :arguments {:ws ws :uid (:uid @globals/fbjwt-payload)}}) set-fb-data-personal-logs)
   {})
 )

(re-frame/reg-event-db
 ::set-post-list-data
 (fn [db [_ data route-load]]
   (-> db
       (assoc-in [:posts :data] data)
       (complete-route-load route-load))))

(re-frame/reg-event-fx
 ::set-post-list-meta
 (fn [{:keys [db]} [_ data]]
   {:db (assoc-in db [:posts :meta] data)}))


(re-frame/reg-event-fx
 ::set-post-list-batch-meta
 (fn [{:keys [db]} [_ data]]
   {:db (assoc-in db [:posts :batch-meta] data)}))

(re-frame/reg-event-db
 ::set-post-list-batch-datetime
 (fn [db [_ datetime]]
   (assoc-in db [:posts :batch-datetime] datetime)))

(defn raidize-result-data
  ([data]
   (raidize-result-data data false))
  ([data skip-interval-id-check]
   (when-let [result-data (not-empty data)]
     (let [eids (get-distinct-eids result-data)]
       (worker-pool/do! {:handler :raidize-eids, :arguments {:data eids}})))
   ))


;;  TODO: do this with separate methods, list-success and list-batch-success (cleaner)

;;  Something to think about: If the rewrite happens on click, we'll save some regex execution time.
;;  If someone tries to open a post in a new tab, we can redirect them on backend to the new url.
;;  Redirects were handled on server in Castor but we don't do that in Iris because we would lose state/reload the app.
;;  Therefore rewriting on client is the best option, but if someone opens a post in a new tab, they lose state/reload the app anyway.

(def request-screening-statuses screening/request-screening-statuses)

 (re-frame/reg-event-fx
  ::http-get-post-list-success
  [(events/api-msg-interceptor {:mute-keys #{:result}})]
  (fn [{:keys [db]} [_ query-params predata curr-interval-id data]]

    (let [sdd (get-in db [:posts :data])
          bmd (get-in db [:posts :batch-meta])
          md (get-in data [:result :meta])
          dd (add-ws-to-refs (get-in data [:result :data]) (:ws query-params))
          pd (if (empty? predata) predata (if (vector? predata) predata (conj [] predata)))
          ad (if (empty? pd) dd (reduce conj pd dd))]

      (re-frame/dispatch [::set-post-list-meta md])
      (re-frame/dispatch [::set-post-list-data ad (query-route-load query-params)])
      (re-frame/dispatch [::http-complete])

      (if (= (:next_bookmark md) (:next_page_bookmark bmd))
        (println "HIT: " (:next_bookmark md) " " (:next_page_bookmark bmd))
        (println "MISS: " (:next_bookmark md) " " (:next_page_bookmark bmd)))

      ;; TODO: ::set-post-fb-data gets dispatched here but it gets data from db
      ;; which means it runs on all data on every post list success - perhaps it should be dd only
      ;; when being run from here and all data when run from interval code??
      (let [continue-loading? (and (true? (:has_more md))
                                   (not= (:next_bookmark md) (:next_page_bookmark bmd))
                                   (= @background/interval-id curr-interval-id))]
        (when (not-empty dd)
          (if continue-loading?
            (screening/queue-screening-statuses dd)
            (screening/flush-screening-statuses db dd {:prevent-http-complete true}))
          (re-frame/dispatch [::set-post-fb-data dd])
          (re-frame/dispatch [::admin-all-moderation-logs dd]))
        (when (and (not continue-loading?) (empty? dd))
          (screening/flush-screening-statuses db nil {:prevent-http-complete true}))
        (when continue-loading?
          (re-frame/dispatch [::http-get-post-list
                              (with-route-load
                                (merge query-params {:nbm (get-in md [:next_bookmark])})
                                (query-route-load query-params))
                              ad
                              curr-interval-id]))))
    {}))





 (re-frame/reg-event-fx
  ::http-get-post-list-batch-success
  [(events/api-msg-interceptor {:mute-keys #{:result}})]
  (fn [{:keys [db]} [_ query-params predata data]]

    (let [sdd (get-in db [:posts :data])
          md (get-in data [:result :meta])
          dd (add-ws-to-refs (get-in data [:result :data]) (:ws query-params))
          pd (if (empty? predata) predata (if (vector? predata) predata (conj [] predata)))
          ad (if (empty? pd) dd (reduce conj pd dd))]

      (re-frame/dispatch [::set-post-list-batch-meta md])
      (re-frame/dispatch [::set-post-list-data ad (query-route-load query-params)])
      (re-frame/dispatch [::set-post-list-batch-datetime (.now js/Date)])
      (re-frame/dispatch [::http-complete])

      (when (not-empty dd)
        (background/interval-start)
        (request-screening-statuses db dd {:prevent-http-complete true})
        (re-frame/dispatch [::set-post-fb-data dd])
        (re-frame/dispatch [::admin-all-moderation-logs dd])
        (when (and (true? (:has_next_batch md))
                   (not= (:next_batch_bookmark md) (:next_page_bookmark md)))
          (re-frame/dispatch [::http-get-post-list
                              (with-route-load
                                (merge query-params {:nbm (get-in md [:next_batch_bookmark])})
                                (query-route-load query-params))
                              ad
                              @background/interval-id])))


      )
    {}))


(re-frame/reg-event-fx
 ::http-get-post-list-failure
  [(events/api-msg-interceptor {})]
  (fn [{:keys [db]} [_ query-params]]
    {:db db
     :fx [[:dispatch [::route-posts-load-complete (query-route-load query-params)]]
          [:dispatch [::http-complete]]]}))


(re-frame/reg-event-fx
 ::set-defaults-ws-fb
 (fn [e [_ ws]]
  ;; switching to local storage
   (fb/set-defaults-ws ws)
  ;;  (localstorage/set-item! "iris.defaults.ws" ws)
   (sessionstorage/set-item! "iris.defaults.ws" ws)
   {}))



;; TODO: this often gets null so investigate why
(defn get-defaults-from-query-params [qp]
  ;; commented out ones are filters that must be present in url
  ;; perhaps comment them out from db as well? or just keep it there for defaults?
  ;; need ws here too, but passed into scopes somehow
  ;; NOTE: added/merged ws in ::query-params subs
  ;; NOTE: if page is not defined, starting with {:page 1} will default it to 1
  ;; perhaps others should be defaulted here as well
  (cond-> {:page 1 :layout nil :excerpt nil}
    ;; NOTE: ws here is experimental, perhaps it shouldn't be here
    (:ws qp) (assoc :ws (:ws qp))
    (:page qp) (assoc :page (int (:page qp)))
    (:limit qp) (assoc :limit (int (:limit qp)))
    ;; (:level qp) (assoc :level (int (:level qp)))
    ;; (:status qp) (assoc :status (:status qp))
    ;; (:flag qp) (assoc :flag (:flag qp))
    ;; (:staff qp) (assoc :staff (:staff qp))
    ;; (:sort qp) (assoc :sort (:sort qp))

    (:layout qp) (assoc :layout (:layout qp))

    (:excerpt qp) (assoc :excerpt (:excerpt qp))

    (:raw qp) (assoc :excerpt (:excerpt qp))))


;; this is problematic, some of these params should NOT stay until overwritten
;; perhaps just limit should be left? maybe not even that
(re-frame/reg-event-db
 ::set-posts-defaults-from-qp
 (fn [db [_ qp]]
   (let [defaults (get-defaults-from-query-params qp)]
     (when (and (:ws defaults)
                (not= (:ws defaults)
                      ;; (get-in db [:posts :ws])
                      (:ws db)))
      ;;  TODO: set-defaults-ws-fb happens only here, but if you change ws from analytics, default doesn't get set
      ;;  maybe this should be moved out to "::set-defaults-..." instead of "::set-posts-defaults-..."
       (re-frame/dispatch [::set-defaults-ws-fb (:ws defaults)]))
    ;;  (assoc-in db [:posts] (merge (:posts db) defaults))
    ;;  Note: we moved :ws to topmost level. So...
    ;;  - dissoc :ws from defaults so it doesn't get merged under :posts
    ;;  - assoc-in topmost [:ws] but only if it is provided in defaults (don't want to override if it's not already there)
    ;; Keep in mind that depending how it's called defaults might be empty or not, for example:
    ;; (:ws defaults) {:page 1, :layout nil, :excerpt yes, :ws TSC, :limit 50}
    ;; (:ws defaults) {:page 1, :layout nil, :excerpt nil}
     (-> db
         (assoc-in [:posts] (merge (:posts db) (dissoc defaults :ws)))
         (assoc-in [:ws] (or (:ws defaults) (:ws db)))))))


(def prev-query-params (atom nil))
(def prev-panel (atom nil))

(re-frame/reg-cofx
 :header-loaded
 (fn [cofx]
   (let [[_ qp ruid] (:event cofx)]
     (assoc cofx :header-loaded (= ruid (get-in cofx [:db :posts :header :ruid]))))))

;; TODO: could refactor panel vs prev-panel check into another coeffect
(re-frame/reg-cofx
 :pq
 (fn [cofx _]
   (let [[_ query-params] (:event cofx)
         ws (get-in cofx [:db :ws])
         limit (get-in cofx [:db :posts :limit])
         panel (get-in cofx [:db :route :panel])
         prev-panel (get-in cofx [:db :prev-route :panel])
         prev-query-params (get-in cofx [:db :prev-route :route :query-params])]

    ;;  Notes:
    ;;  query-params may contain params that are not even in url, for example  {:ws TLO, :limit 50, :board +1tukFroX, :level 2, :pq-check false}
    ;;  or :nbm Ck0KFwoKY3JlYXRlZF9kdBIJCLzd68G7xPoCEi5qDHN-cmstZ2VhLWRldnIYCxIEUG9zdCIOKjFpWUtkTFhPLTNkYWQMogEDZGV2GAAgAQ==
    ;;  :nbm (inserted while batch loading)
    ;;  if query-params and prev-query-params are not the same (unwanted params excluded)
    ;;  pass into cofx context param load posts :pq-load-posts-ok to load posts
    ;;  used "apply" to flatten the collection [:layout] into argument list
    ;;  casted as string so :limit 50 and :limit "50" would be equal (first load issue)

    ;; :pq-check false? - if coming from thread-flow (first load OP then the replies) we let it load
    ;; regardless if the previous query params are the same or not.
    ;; That way if replying multiple times to the same OP the posts will be loaded (otherwise won't)
    ;; 12/21/22 when adding table view to thread panel, noticed that posts were reloading - even though stitching layout shouldn't do that.
    ;; The reason why it reloads in thread is because of :pq-check set to false in thread flow

    ;;  testing ws and limit from db against ws,limit from query-params because on first load they are not set in url/query-params however on all next btn clicks they are in url
    ;;  later excluding them from from qp vs pqp because it is possible that they are in query-params and NOT in prev-query-params (that doesn't matter though because they are set in db, which is previously checked)

     (when (or (false? (:pq-check query-params))
               (not= ws (:ws query-params))
               (not= limit (int (:limit query-params)))
               (not= panel prev-panel)
               (not= (utils/map-kv str (apply dissoc query-params [:layout :excerpt :raw :ws :limit]))
                     (utils/map-kv str (apply dissoc prev-query-params [:layout :excerpt :raw :ws :limit]))))
       (assoc cofx :pq-load-posts-ok true)))))

 (re-frame/reg-event-fx
  ::http-get-post-list
  [(re-frame/inject-cofx :pq)]
  (fn [{:keys [db] :as cofx} [e query-params predata interval-id]]
    ;; TODO: in case of excerpt yes - interval is stopped but not continued
    ;; needs to be moved inside :pq-load-posts-ok true?
    ;; TODO: revisit interval-end, because of lazy loading things changed

    ;; perhaps this should happen elsewhere, currently Post.List runs before db gets updated with defaults
    ;; TODO: since batch is run first, is there a need to run this here??
    (re-frame/dispatch [::set-posts-defaults-from-qp query-params])
    (when (empty? predata)
      (re-frame/dispatch [::reset-screening-status-request-tracking]))

    ;; flag and staff params need to be added to post-rpc but api currently doesn't support it

    ;; for layout: perhaps some kind of filter here which compares state in db with query params. Trigger Post.List load only if crucial params changed not the one like "layout". Also interval need to be taken into consideration, not sure if it is needed in table view, but again maybe triggering it once user switched back to list is unnecessary complication
    ;; another option is maybe some kind of skip load atom set to true by table/list buttons, loaded in post.list effect as cofx :skip-load and reset to false

    ;; save prev-query-parameters and if same with new ones (excluding layout) do not load - possible problem with scroll loading although we maybe could use bookmarks with params
    ;; maybe in interceptor

;; TODO: there is a problem when comparing :limit 50 and :limit "50" (int vs string)
    ;; next time around that problem dissapears but first time is present

    (when (true? (:pq-load-posts-ok cofx))
      (events/post-rpc {:jsonrpc "2.0"
                        :id 0
                        :method "Post2a.List"
                        :params {:options {:debug false}
                                 :data (merge {:include_screening_status false
                                               :scopes (get-scopes-from-query-params query-params)
                                               :status (or (:status query-params) (get-in db [:posts :status]))
                                               :sort_by (or (:sort query-params) (get-in db [:posts :sort]))
                                               :bookmark (:nbm query-params)
                                      ;; had to eliminate pulling page from db because it pulls 11 (::set-posts-defaults doesn't get executed in time)
                                               :limit (if (< (int (:limit query-params)) 50) (int (:limit query-params)) 50)
                                               :ruids_only false}
                                              (when-let [staff (cond (= (:staff query-params) "yes") "yes"
                                                                     (= (:staff query-params) "no") "no"
                                                                     :else nil)]
                                                {:staff staff})
                                              (when-let [flag (:flag query-params)]
                                                {:flag flag}))
                                 }}
                       [::http-get-post-list-success query-params predata interval-id]
                       [::http-get-post-list-failure query-params]
                       [::events/track-request "Post.List"]))))


(re-frame/reg-event-fx
 ::http-get-post-list-debounced
 (fn [e [_ query-params]]
   {::events/dispatch-debounce ["Post.List"
                                [::http-get-post-list query-params]
                                1000]}))



(re-frame/reg-event-fx
 ::http-get-post-success
 [(events/api-msg-interceptor
   ;;  ruid to link turned off per request in IRS-54 
   ;;  {:result-modifier-fn (fn [msg] (ruid-to-ahref msg))}
   {})]
 (fn [{:keys [db]} [_ data]]
   ;;  TODO: probably should be refactored into a function, it is used in search as well as posts lists
   (if-let [d (get-in data [:result :data])]
     (do
       ;; post found, process data, update db in effect
       ;; get post votes/reactions, replies (TODO: this could be turned into function, it's called from other places we well)

       (let [dd (conj [] d)]
         (when (not-empty dd)
          ;; get post votes/reactions, replies
           (request-screening-statuses db dd {:prevent-http-complete true})
           (re-frame/dispatch [::set-post-fb-data dd])))

       {:db db})
     (do
       ;; post not found, process error message, return empty effect
       (println (get-in data [:error :message]))
       {}))))


(re-frame/reg-event-fx
 ::http-get-post-failure
 [(events/api-msg-interceptor {})]
 (fn [_ data]))


;; cofx injection checks if already loaded?
 (re-frame/reg-event-fx
  ::http-get-post
  (fn [e [_ ruid]]
    (events/post-rpc {:jsonrpc "2.0"
                      :id 0
                      :method "Post2a.Get"
                      :params {:options {:debug false}
                               :data {:ruid ruid
                                      :include_screening_status false}}}
                     [::http-get-post-success]
                     [::http-get-post-failure])))



;; perhaps eid/reid and fb data could be added as effects to rules for processing
(defn thread-flow
  [query-params]
  (let [route-load (query-route-load query-params)]
    {:first-dispatch [::http-get-post (str "@OP" (:board query-params))]              ;; what event kicks things off ?
   :rules [;; a set of rules describing the required flow
           {:when :seen?
            :events ::http-get-post-success
            :dispatch-fn (fn [[e result-data]]
                           (if (:error result-data)
                             [[::error-events/set-error {:title "Error: Post not found!"
                                                         :message (get-in result-data [:error :message])
                                                         :a-href "/posts"
                                                         :a-txt "Return to Posts"}]
                              [::route-posts-load-complete route-load]]
                             (let [post (get-in result-data [:result :data])
                                   ws (:ws post)]
                               (cond-> [[::http-get-post-list-batch
                                         (conj query-params {:pq-check false :ws ws})
                                         (add-ws-to-refs (conj [] post) ws)]
                                        [::admin-all-moderation-logs (conj [] post)]]
                                 ws
                                 (conj [::personal-moderation-logs ws])))))}
           {:when :seen?
            :events ::http-get-post-failure
            :dispatch [::route-posts-load-complete route-load]}
           {:when :seen?
            :events ::http-get-post-list-batch-success
           :halt? true
           }]}))


(defn thread-route-query-params
  [route]
  (let [route-data (:route route)
        id (get-in route-data [:route-params :id])]
    (when id
      (merge (:query-params route-data)
             {:board (str "+" id)
              :level 2}))))


(defn thread-load-key
  [query-params]
  (select-keys query-params [:board :level :bm :limit :status :sort :staff :flag]))


(re-frame/reg-event-fx
 ::http-get-thread
 [events/redo-interceptor]
 (fn [e [_ query-params]]
   {:async-flow (thread-flow query-params)}))






(defn reload-post-flow
  [ruid]
  {:first-dispatch [::http-get-post ruid]
   :rules [{:when :seen?
            :events ::http-get-post-success
            :dispatch-fn (fn [[e result-data]]
                           [[::update-posts-data-row ruid (get-in result-data [:result :data])]
                            [::http-complete]])
            :halt? true}]})


(re-frame/reg-event-fx
 ::http-reload-post
 (fn [e [_ ruid]]
   {:async-flow (reload-post-flow ruid)}))




;; TODO: function not used anymore but careful - most likely should be "mapv" instead of map
(re-frame/reg-event-db
 ::push-admin-moderation-log
 (fn [db [_ data]]
   (update-in db [:posts :moderation-log-data] conj data)))

(def create-screen-api-msg-options
  {:result-modifier-fn (fn [msg] (string/replace msg #"/screen/" "/screening/"))
   :error-modifier-fn (fn [msg] (string/replace msg #"/screen/" "/screening/"))})

(re-frame/reg-event-fx
 ::http-create-screen-success
[(events/api-msg-interceptor (assoc create-screen-api-msg-options
                                    :id :http-create-screen-success-api-msg-interceptor))]
 (fn [{:keys [db]} [_ data]]
   (let [scopes (get-in data [:result :data :scopes])]
     {:db db
      :fx (into [[:dispatch [::http-complete]]]
                (map (fn [scope]
                       [:dispatch [::http-get-screening-status scope]]))
                scopes)})))


(re-frame/reg-event-fx
 ::http-create-screen-failure
 [(events/api-msg-interceptor {})]
 (fn [{:keys [db]}]
   {:db db
    :fx [[:dispatch [::http-complete]]]}))


(re-frame/reg-event-fx
 ::screen-create
 (fn [e [_ data]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                     :method "Screen.Create"
                     :params {:options {:debug false}
                              :data data}}
                    [::http-create-screen-success]
                    [::http-create-screen-failure]
                    nil
                    create-screen-api-msg-options)))








(re-frame/reg-event-fx
 ::http-thread-refresh-replies-success
 [(events/api-msg-interceptor {})]
 (fn [{:keys [db]} [_ id data]]
   (let [n (get-in data [:result :data :n_replies])
         d (new js/Date (get-in data [:result :data :iso_last]))
         t (/ (- (.getTime d) (* (.getTimezoneOffset d) 60000)) 1000)]
     {:db (assoc-in db [:posts :fb-data :replies (str "@OP" id)] {:n n :t t})
      :fx [[:dispatch [::http-complete]]]})))


(re-frame/reg-event-fx
 ::http-thread-refresh-replies-failure
 [(events/api-msg-interceptor {})]
 (fn [{:keys [db]}]
   {:db db
    :fx [[:dispatch [::http-complete]]]}))


(re-frame/reg-event-fx
 ::http-thread-refresh-replies
 (fn [e [_ id]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                     :method "Thread.RefreshReplies"
                     :params {:options {:debug false}
                              :data id}}
                    [::http-thread-refresh-replies-success id]
                    [::http-thread-refresh-replies-failure])))



;; TODO: there is an issue here on localhost, plus-iof line (api response probably changed)
;; Current create responses provide result.data.ruid and thread_path, not the older :id shape.
;; Also, TODO: when doing redirect anchor scrolling on new post doesn't work very well
(re-frame/reg-event-fx
 ::http-post-create-success
 [(events/api-msg-interceptor {:id :http-post-create-success-api-msg-interceptor
                               :result-modifier-fn (fn [msg] (ruid-to-ahref msg))})]
 (fn [{:keys [db]} [_ dm data]]
   (let [ruid (get-in data [:result :data :ruid])
         success-cb (:on-success dm)
         error-msg (get-in data [:error :message])
         error-cb (:on-error dm)]
     (when (and ruid success-cb)
       (success-cb))
     (when (and error-msg error-cb)
       (error-cb error-msg))
     (if (and ruid (nil? success-cb))
       (let [plus-iof (string/index-of ruid "+")
             prefix (subs ruid 1 plus-iof)
             suffix (subs ruid (+ plus-iof 1))
             route-str (routes/url-for :thread :id (str suffix "#" prefix))
             follow-up-events (cond-> [[::events/route-to route-str]]
                                (= prefix "OP")
                                (conj [::events/reset-form "op-form"])

                                (not= prefix "OP")
                                (conj [::http-get-thread {:board (str "+" suffix) :level 2}]
                                      [::events/reset-form "reply-form"]))]
         {:db db
          :fx (into [[:dispatch [::http-complete]]]
                    (map (fn [event] [:dispatch event]))
                    follow-up-events)})
       {:db db
        :fx [[:dispatch [::http-complete]]]}))))


(re-frame/reg-event-fx
 ::http-post-create-failure
 [(events/api-msg-interceptor
   {:id :http-post-create-failure-api-msg-interceptor
    :debug-message-modifier-fn (fn [msg] (str "Post Create API failure: " msg))})]
 (fn [{:keys [db]}]
   {:db db
    :fx [[:dispatch [::http-complete]]]}))


(re-frame/reg-event-fx
 ::post-create
 (fn [e [_ data dm]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                     :method "Post2a.Create"
                     :params {:options {:debug false}
                              :data (merge {
                                            :isHidden false
                                            :countdown 0}
                                           data)}}
                    [::http-post-create-success dm]
                    [::http-post-create-failure])))




(re-frame/reg-event-db
 ::set-posts-filters-from-qp-data
 (fn [db [_ data]]
   (assoc-in db [:posts :filter-data] data)))


(defn prefix-query-param [param value]
  (cond  (= param :ws)
         (str "." value)
         (= param :cc)
         (str ":" value)
         (= param :ip)
         (str "^" value)
         (= param :thread)
         (str "+" value)
         :else
         value))

(re-frame/reg-event-fx
 ::set-posts-filters-from-qp
 (fn [{:keys [db]} [_ qp]]
   ;; this is for posts section filters only, has nothing to do with eid, ip, cc sections
   (let [qp-labels {:ws "Website"
                    :geo "Geo"
                    :lang "Languages"
                    :user "User"
                    :mime "MIME"
                    :ua "UA"
                    :cc "Country"
                    :ip "IP"
                    :cookie "Cookie"
                    :bfp "BFP"
                    :dfp "DFP"
                    :thread "Thread"
                    :board "Board"}
         qp-raidizable #{:geo
                         :lang
                         :mime
                         :ua
                         :cookie
                         :bfp
                         :dfp}
         qp-labels-filtered (filterv #(% qp-labels) (keys qp))
         raid-len (:raid-len db)]

     (go
       (when-let [filter-data
                  (loop [qp-lf qp-labels-filtered
                         results []]
                    (if (some? (first qp-lf))
                      (let [f (first qp-lf)
                            r (conj results {:param f
                                             :label (f qp-labels)
                                             :value (if (and (not-empty (f qp)) (contains? qp-raidizable f))
                                                      (hench/eid-len-raid (f qp) raid-len)
                                                      (prefix-query-param f (f qp)))})]
                        (recur (rest qp-lf) r))
                      results))]
         (re-frame/dispatch [::set-posts-filters-from-qp-data filter-data]))))
         {}))


(re-frame/reg-event-fx


 ::http-get-post-list-batch
 [(re-frame/inject-cofx :pq)]
 (fn [{:keys [db] :as cofx} [e query-params predata]]
    ;; TODO: in case of excerpt yes - interval is stopped but not continued
    ;; needs to be moved inside :pq-load-posts-ok true?
  ;; TODO: revisit interval end start stuff, because of lazy loading things changed
    ;; (interval-end)
   ;; perhaps this should happen elsewhere, currently Post.List runs before db gets updated with defaults
   (re-frame/dispatch [::set-posts-defaults-from-qp query-params])
   (when (empty? predata)
     (re-frame/dispatch [::reset-screening-status-request-tracking]))

    ;; flag and staff params need to be added to post-rpc but api currently doesn't support it

    ;; for layout: perhaps some kind of filter here which compares state in db with query params. Trigger Post.List load only if crucial params changed not the one like "layout". Also interval need to be taken into consideration, not sure if it is needed in table view, but again maybe triggering it once user switched back to list is unnecessary complication
    ;; another option is maybe some kind of skip load atom set to true by table/list buttons, loaded in post.list effect as cofx :skip-load and reset to false

    ;; save prev-query-parameters and if same with new ones (excluding layout) do not load - possible problem with scroll loading although we maybe could use bookmarks with params
    ;; maybe in interceptor

;; TODO: there is a problem when comparing :limit 50 and :limit "50" (int vs string)
    ;; next time around that problem dissapears but first time is present

   (when (true? (:pq-load-posts-ok cofx))

     (background/interval-end)

     (events/post-rpc {:jsonrpc "2.0"
                       :id 0
                       :method "Post2a.ListBatch"
                       :params {:options {:debug false}
                                :data (merge {:include_screening_status false
                                              :scopes (get-scopes-from-query-params query-params)
                                      ;;  TODO: look into returning level, it goes in scopes (sometimes) so not sure if needed
                                              :status (or (:status query-params) (get-in db [:posts :status]))
                                              :sort_by (or (:sort query-params) (get-in db [:posts :sort]))
                                              :bookmark (:bm query-params)
                                      ;; had to eliminate pulling page from db because it pulls 11 (::set-posts-defaults doesn't get executed in time)
                                              :batch_limit (if (and (> (int (:limit query-params)) 0) (< (int (:limit query-params)) 50)) (int (:limit query-params)) 50)
                                              :page_limit (int (or (:limit query-params) (get-in db [:posts :limit])))
                                              :ruids_only false}
                                             (when-let [staff (cond (= (:staff query-params) "yes") "yes"
                                                                    (= (:staff query-params) "no") "no"
                                                                    :else nil)]
                                               {:staff staff})
                                             (when-let [flag (:flag query-params)]
                                               {:flag flag}))
                                }}
                      [::http-get-post-list-batch-success query-params predata]
                      [::http-get-post-list-failure query-params]
                      [::events/track-request "Post.ListBatch"]))))


(re-frame/reg-event-fx
 ::http-get-post-list-batch-debounced
 [events/redo-interceptor]
 (fn [e [_ query-params]]
   {::events/dispatch-debounce ["Post.ListBatch"
                                [::http-get-post-list-batch query-params]
                                1000]}))





;; Scope.GetLogTimespan ti vrati first_seen i last_seen

;; Scope.GetEidMetadata ti vrati dekriptovani ruid

;; Za screening status imas vec postojecu metodu ScreeningStatus.Get koja prima ili jedan ruid (ruid=...) ili listu (ruids= [...])


(re-frame/reg-event-fx
 ::http-get-scope-eid-metadata-success
 [(events/api-msg-interceptor {:mute-keys #{:result}})]
 (fn [{:keys [db]} [_ eid data]]
   (let [result-data (get-in data [:result :data])]
     {:db (assoc-in db [:posts :eid :metadata eid] result-data)
      :fx [[:dispatch [::http-complete]]]})))


(re-frame/reg-event-fx
 ::http-get-scope-eid-metadata-failure
 [(events/api-msg-interceptor {})]
 (fn [{:keys [db]}]
   {:db db
    :fx [[:dispatch [::http-complete]]]}))


(re-frame/reg-event-fx
 ::http-get-scope-eid-metadata
 (fn [e [_ eid]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                     :method "Scope.GetEidMetadata"
                     :params {:options {:debug false}
                              :data eid}}
                    [::http-get-scope-eid-metadata-success eid]
                    [::http-get-scope-eid-metadata-failure])))




(re-frame/reg-event-fx
 ::http-get-log-timespan-success
 [(events/api-msg-interceptor {:mute-keys #{:result}})]
 (fn [{:keys [db]} [_ data]]
   (let [result-data (get-in data [:result :data])]
     {:db (assoc-in db [:posts :eid :logs] result-data)
      :fx [[:dispatch [::http-complete]]]})))


(re-frame/reg-event-fx
 ::http-get-log-timespan-failure
 [(events/api-msg-interceptor {})]
 (fn [{:keys [db]}]
   {:db db
    :fx [[:dispatch [::http-complete]]]}))


(re-frame/reg-event-fx
 ::http-get-log-timespan
 (fn [e [_ eid]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                     :method "Scope.GetLogTimespan"
                     :params {:options {:debug false}
                              :data eid}}
                    [::http-get-log-timespan-success]
                    [::http-get-log-timespan-failure])))



;; TODO: search result data needs to be tied with eid/raid
(re-frame/reg-event-db
 ::http-post-search-success
 [(events/api-msg-interceptor {})]
 (fn [db [_ ws route-load data]]
   (re-frame/dispatch [::set-post-list-batch-datetime (.now js/Date)])
   (re-frame/dispatch [::http-complete])

   (let [result-data (add-ws-to-refs (get-in data [:result :data]) ws)
         result-meta (or (get-in data [:result :meta]) (get-in data [:error]))]

    ;;  TODO: problem with this is data result data does not contain "eids" (:author :eid) so there is nothing to raidize

     (when (not-empty result-data)
       (background/interval-start)
       (request-screening-statuses db result-data {:prevent-http-complete true})
       (re-frame/dispatch [::set-post-fb-data result-data])
       (re-frame/dispatch [::admin-all-moderation-logs result-data])
       )

     (-> db
         (assoc-in [:posts :data] result-data)
         (complete-route-load route-load)
         (assoc-in [:posts :meta] (dissoc result-meta :screening_status))
         ))))


(re-frame/reg-event-fx
 ::http-post-search-failure
 [(events/api-msg-interceptor {})]
 (fn [{:keys [db]} [_ route-load]]
   {:db db
    :fx [[:dispatch [::route-posts-load-complete route-load]]
         [:dispatch [::http-complete]]]}))


(re-frame/reg-event-fx
 ::http-post-search
 (fn [e [_ ws index limit order page q maxcount route-load]]

   (re-frame/dispatch [::set-posts-meta nil])
   (re-frame/dispatch [::reset-screening-status-request-tracking])

   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                     :method "Post2a.Search"
                     :params {:options {:debug false}
                              :data (merge {:include_screening_status false
                                            :index index
                                            :limit (int limit)
                                            :order order
                                            :page (int page)
                                            :ws ws
                                            :q q
                                            :ruids_only false}
                                           (when (> maxcount 0)
                                             {:number_found_accuracy maxcount}))}}
                    [::http-post-search-success ws route-load]
                    [::http-post-search-failure route-load])))









 (re-frame/reg-event-fx
 ::http-get-latest-post-list-success
  [(events/api-msg-interceptor {})]
 (fn [{:keys [db]} [_ query-params data]]

   (let [md (get-in data [:result :meta])
         dd (add-ws-to-refs (get-in data [:result :data]) (:ws query-params))]

     (re-frame/dispatch [::set-post-list-meta md])
     (re-frame/dispatch [::set-post-list-data dd (query-route-load query-params)])
     (re-frame/dispatch [::set-post-list-batch-datetime (.now js/Date)])
     (re-frame/dispatch [::http-complete])

     (when (not-empty dd)
       (request-screening-statuses db dd {:prevent-http-complete true})
       (re-frame/dispatch [::set-post-fb-data dd]))
     )
   {}))



 (re-frame/reg-event-fx
 ::http-get-latest-post-list-failure
  [(events/api-msg-interceptor {})]
  (fn [{:keys [db]} [_ query-params]]
    {:db db
     :fx [[:dispatch [::route-posts-load-complete (query-route-load query-params)]]
          [:dispatch [::http-complete]]]}))


(re-frame/reg-event-fx
 ::http-get-latest-post-list
 [(re-frame/inject-cofx :pq) events/redo-interceptor]
 (fn [{:keys [db] :as cofx} [e query-params]]

   (re-frame/dispatch [::set-posts-defaults-from-qp query-params])
   (re-frame/dispatch [::reset-screening-status-request-tracking])

   (when (true? (:pq-load-posts-ok cofx))

     (background/interval-end)

     (events/post-rpc {:jsonrpc "2.0"
                       :id 0
                       :method "Post.List"
                       :params {:options {:debug false}
                                :data (merge {:include_screening_status false
                                              :scopes (get-scopes-from-query-params query-params)
                                              :level 1
                                              :status "P"
                                              :sort_by "submitted"
                                           ;; had to eliminate pulling page from db because it pulls 11 (::set-posts-defaults doesn't get executed in time)
                                              :limit 75
                                              :ruids_only false}
                                             (when-let [staff (cond (= (:staff query-params) "yes") "yes"
                                                                    (= (:staff query-params) "no") "no"
                                                                    :else nil)]
                                               {:staff staff})
                                             (when-let [flag (:flag query-params)]
                                               {:flag flag}))
                                }}
                      [::http-get-latest-post-list-success query-params]
                      [::http-get-latest-post-list-failure query-params]
                      [::events/track-request "Post.List"])

     )

   ))


(re-frame/reg-event-fx
 ::http-get-latest-post-list-debounced
 (fn [e [_ query-params]]
   {::events/dispatch-debounce ["Post.ListLatest"
                                [::http-get-latest-post-list query-params]
                                1000]}))


(re-frame/reg-event-db
 ::set-admin-moderation-logs
 (fn [db [_ value]]
   (assoc-in db [:posts :moderation-log-data] value)))


(re-frame/reg-event-db
 ::set-admin-all-moderation-logs
 (fn [db [_ id value]]
   (assoc-in db [:posts :all-moderation-log-data (keyword id)] value)))

;; TODO: if the original set-admin-all-moderation-logs event is no longer in use, delete and rename the one below
(re-frame/reg-event-db
 ::set-admin-all-moderation-logs-2
 (fn [db [_ value]]
   (assoc-in db [:posts :all-moderation-log-data]
             (merge (get-in db [:posts :all-moderation-log-data]) value))))

(re-frame/reg-event-db
 ::update-post-props
 (fn [db [_ id updates]]
   (let [data (get-in db [:posts :data])
         new-data (mapv (fn [item]
                         (if (= id (:id item))
                           (merge item updates)
                           item)) data)]
     (assoc-in db [:posts :data] new-data))))


(def fetch-post ref-preview/fetch-post)
(def set-post-ref-preview-data ref-preview/set-post-ref-preview-data)
(def fetch-cache-set-post-ref-preview-data ref-preview/fetch-cache-set-post-ref-preview-data)
(def load-post-ref-from-a-pref-mouseover-event ref-preview/load-post-ref-from-a-pref-mouseover-event)
